import React from "react";
import { ui } from "@/strings";

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class HighlightErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Highlight rendering error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="rounded-xl border border-semantic-error/30 bg-semantic-error-bg p-4">
          <p className="font-medium text-semantic-error">
            {ui.errors.highlightsNotDisplayed}
          </p>
          <p className="mt-1 text-sm text-semantic-error">
            {ui.errors.highlightsErrorExplanation}
          </p>
          {this.state.error && (
            <details className="mt-2">
              <summary className="cursor-pointer text-sm text-semantic-error">
                {ui.errors.technicalDetails}
              </summary>
              <pre className="mt-1 text-xs text-semantic-error">
                {this.state.error.message}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}
